export default __webpack_public_path__ + "images/curve-desk.svg";